
import { Controller } from "stimulus";

export default class extends Controller {

    static targets = ["line_item_total_holder", "invoice_total_before_vat", "invoice_vat_total", "invoice_grand_total"]

    currencify(amount) {
        return (Number(amount).toLocaleString()) + ` ${_global_currency_code}`
    }
    calculateInvoiceTotal() {
        
        // console.log("calculateInvoiceTotal FIRED!")
        // console.log("line_item_total_holderTarget: " + this.line_item_total_holderTargets)

        let invoiceTotal = 0.0
        let invoiceTaxTotal = 0.0
        let totalDeductions = 0.0
        this.line_item_total_holderTargets.forEach(element => {
            invoiceTotal += parseFloat( element.getAttribute("data-invoice-line-item-total"))
            invoiceTaxTotal += parseFloat( element.getAttribute("data-invoice-line-item-tax-amount"))
        });

        console.log("Invoice Total: " + invoiceTotal)
        console.log("Invoice Tax Total: " + invoiceTaxTotal)

        this.invoice_total_before_vatTarget.innerHTML = this.currencify(invoiceTotal)

        this.invoice_vat_totalTarget.innerHTML = this.currencify(invoiceTaxTotal)
        const grandTotal = invoiceTotal + invoiceTaxTotal
        this.invoice_grand_totalTarget.innerHTML = this.currencify(grandTotal)
        // const quantity = this.quantityTarget.value
        // const rate = this.rateTarget.value

        // const total = quantity * rate
        // const tax_rate = this.tax_rateTarget.value
        // this.display_totalTarget.innerHTML = this.currencify(total)
        // debugger
        // this.data.set("total", total)
        // this.data.set("tax-amount", total * (tax_rate / 100))

    }
    updateInvoiceTotal(){
        console.log("updateInvoiceTotal FIRED!")
        
    }

}